"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lvCountry = void 0;
var _utils = require("../utils");
// i18next-extract-mark-ns-start Countries

var lvCountry = exports.lvCountry = function lvCountry(t) {
  return {
    id: 'LV',
    name: t('Latvia'),
    flag: '🇱🇻',
    zipcodeChecker: function zipcodeChecker(zipcode) {
      return (zipcode === null || zipcode === void 0 ? void 0 : zipcode.length) === 4;
    },
    zipcodeMatcher: _utils.defaultZipcodeMatcher,
    zipcodePlaceholder: 'e.g. 1050 or 8000',
    phonePrefix: '371',
    phoneLength: 8,
    pricingVersion: 14,
    timezone: 'Europe/Riga',
    currency: 'EUR'
  };
};